import grey from '@material-ui/core/colors/grey';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;
export type UserContentStylesProps = {
	spacing: number;
	zoomLayer: boolean;
};

export const MOBILE_HEADER_BREAKPOINT = '812px';
export const useStyles = makeStyles(theme => {
	return {
		showroomFooter: {
			color: 'white',
			backgroundColor: 'black',
			minHeight: 100,
			display: 'flex',
			alignItems: 'center',
			paddingBottom: 50
		},
		showroomFooterContainer: {
			display: 'flex',
			flexWrap: 'wrap'
		},
		showroomFooterGridContainer: {
			[theme.breakpoints.up('sm')]: {
				width: 'calc(100% + 10px)',
				marginLeft: -5,
				marginRight: -5
			}
		},
		showroomFooterSectionTitle: {
			fontSize: 14,
			textTransform: 'uppercase',
			color: grey[500],
			marginBottom: 5
		},
		showroomFooterColumn: {
			display: 'flex',
			flexDirection: 'column',
			padding: '0 10px',
			[theme.breakpoints.down('sm')]: {
				marginBottom: 25,
				padding: 0,
				'&:last-child': {
					marginBottom: 0
				}
			}
		},
		showroomFooterPrContactName: {
			fontSize: 17,
			lineHeight: '24px'
		},
		showroomFooterLink: {
			display: 'inline-block',
			alignSelf: 'flex-start',
			textDecoration: 'none',
			color: 'white',
			fontSize: 14,
			lineHeight: '24px',
			maxWidth: '100%',

			'&:hover': {
				textDecoration: 'underline'
			}
		},
		showroomFooterPdf: {
			display: 'inline-flex',
			alignItems: 'center'
		},
		showroomFooterPdfIcon: {
			fontSize: 18,
			marginRight: 10
		},
		showroomFooterPdfLabel: {
			fontSize: 14
		}
	};
});
